var getUserType = require('../utils/get-user-type')
var ListController = require('billy-webapp/ui/list/controller')

module.exports = ListController.extend({
    needs: ['organization', 'application', 'user'],
    organization: Em.computed.alias('controllers.organization.model'),
    activeUmbrella: Em.computed.alias('sideMenu.activeUmbrella'),
    activeMembership: Em.computed.oneWay('userOrganizations.activeMembership'),
    userType: function() {
        return getUserType(this.get('activeMembership'))
    }.property('activeMembership'),

    queryParams: {
        page: 'page',
        pageSize: 'pageSize',
        period: 'period',
        searchQuery: 'searchQuery',
        sortDirection: 'sortDirection',
        sortProperty: 'sortProperty',
        state: 'state'
    },

    customActions: {
        navigate: function(e) {
            var route = e.detail.route
            var options = e.detail.props || { queryParams: {} }
            this.transitionToRoute(route, options)
        }
    }
})
